import { motion } from "framer-motion";
import { ArrowRight, Check, Handshake } from "lucide-react";
import { Reveal } from "./Reveal";

const PERKS = [
  "A proven, play-based early-years curriculum",
  "Complete setup and operational guidance",
  "Teacher training and ongoing support",
  "Brand, marketing and enrolment help",
];

export const Franchise = ({ onEnquire }) => (
  <section id="franchise" data-testid="franchise-section" className="relative py-24 lg:py-32">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2.5rem] bg-forest text-cream px-8 py-14 sm:px-14 sm:py-16 lg:px-20">
          <div className="absolute -top-24 -right-24 w-96 h-96 rounded-full bg-leaf/25 blur-3xl" />
          <div className="absolute -bottom-32 -left-16 w-96 h-96 rounded-full bg-peach/20 blur-3xl" />
          <motion.span
            animate={{ rotate: 360 }}
            transition={{ repeat: Infinity, duration: 24, ease: "linear" }}
            className="absolute top-10 right-10 hidden sm:block opacity-90"
          >
            <Handshake className="w-14 h-14 text-sun" strokeWidth={1.4} />
          </motion.span>

          <div className="relative max-w-2xl">
            <span className="inline-block text-xs font-bold tracking-[0.24em] uppercase text-sun mb-4">
              Franchise Opportunities
            </span>
            <h2 className="font-display font-extrabold tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.08]">
              Bring a Kiwi Kids to{" "}
              <em className="font-quote italic font-medium text-sun">your city</em>
            </h2>
            <p className="mt-5 text-cream/70 text-base sm:text-lg leading-relaxed">
              Join a trusted early-childhood brand — with a curriculum, playbook and team that
              make a warm, joyful preschool possible from day one.
            </p>

            <ul className="mt-9 grid sm:grid-cols-2 gap-3.5">
              {PERKS.map((perk, i) => (
                <motion.li
                  key={perk}
                  initial={{ opacity: 0, x: -20 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.4 }}
                  transition={{ delay: 0.1 + i * 0.08, duration: 0.5 }}
                  className="flex items-center gap-3 bg-white/8 border border-white/10 rounded-2xl px-4 py-3.5 text-sm font-medium backdrop-blur-sm"
                >
                  <span className="shrink-0 w-6 h-6 rounded-full bg-sun flex items-center justify-center">
                    <Check className="w-3.5 h-3.5 text-ink" strokeWidth={3} />
                  </span>
                  {perk}
                </motion.li>
              ))}
            </ul>

            <motion.button
              data-testid="franchise-cta-button"
              onClick={() => onEnquire("franchise")}
              whileHover={{ y: -3 }}
              whileTap={{ scale: 0.97 }}
              className="group mt-10 inline-flex items-center gap-2.5 bg-sun text-ink font-bold px-8 py-4 rounded-full shadow-[0_16px_36px_rgba(255,200,87,0.3)] hover:bg-cream transition-colors duration-300"
            >
              Explore a franchise partnership
              <ArrowRight className="w-5 h-5 transition-transform duration-300 group-hover:translate-x-1.5" />
            </motion.button>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
